import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_NEXT_STEPS = defineFcm('starter_experience_next_steps')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		experimentName: 'starter_experience_next_steps_experiment',
		enabled: false,
	})
	.toConfig();
